<template>
    <Head title="صورتحساب‌های فعال"/>
    <dashboard>
        <template v-slot:breadcrumb>
            <breadcrumb :links="[{title: 'پنل کاربری', url: '/dashboard'}, {title: 'صورتحساب‌های فعال'}]"/>
        </template>

        <div v-if="checkouts.length" class="row">
            <div v-for="checkout in checkouts" class="col-lg-6">
                <Link class="btn btn-primary w-100 text-white" :href="`/checkout/${checkout.uuid}`">تکمیل سفارش {{ checkout.tracking_code }}</Link>
            </div>
        </div>

        <div v-else class="text-center">
            <h3 class="fw-bold mb-4">شما سفارش فعالی ندارید!</h3>
            <a href="/shop"
               class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold fs-6 py-3 px-5">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.69922 7L9.49802 7.47905C9.1732 8.25243 9.09156 9.10637 9.26395 9.92729C9.52699 11.1799 10.5242 12.1473 11.7842 12.3723L11.8951 12.3921C12.2947 12.4635 12.7038 12.4635 13.1033 12.3921L13.2143 12.3723C14.4743 12.1473 15.4714 11.1799 15.7345 9.92729C15.9069 9.10637 15.8252 8.25243 15.5004 7.47905L15.2992 7"
                        stroke="white" stroke-width="1.5" stroke-linecap="round"></path>
                    <path
                        d="M20.7224 15.1432C20.1522 17.6506 18.2032 19.6206 15.7039 20.2254C13.6035 20.7336 11.3998 20.7336 9.29936 20.2254C6.80008 19.6206 4.85107 17.6506 4.2809 15.1432C3.77146 12.9029 3.89536 10.565 4.63873 8.39108L4.74917 8.06811C5.56712 5.6761 7.61047 3.91037 10.0958 3.44791L10.7764 3.32126C11.9168 3.10906 13.0865 3.10906 14.2269 3.32126L14.9075 3.4479C17.3928 3.91037 19.4362 5.6761 20.2541 8.06813L20.3646 8.39109C21.1079 10.565 21.2318 12.9029 20.7224 15.1432Z"
                        stroke="white" stroke-width="1.5"></path>
                </svg>
                ورود به فروشگاه </a>
        </div>

    </dashboard>
</template>

<script>
import Dashboard from '../../Layouts/Dashboard';
import Breadcrumb from "../../Components/Breadcrumb";
import {Head, Link} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Dashboard,
        Breadcrumb,
        Head,
        Link,
    },
    props: {
        checkouts: Array,
    },
}
</script>

<style scoped>

</style>
